import { companyDetails } from "../data/constant";

const PHONE_NUMBER = companyDetails.phone.replace(/[^0-9]/g, "");

export const getContextualWhatsAppUrl = (pathname = "") => {
  let message = "Hi PANTHM AI Labs! I visited your website and would like to know more about your services.";

  if (!pathname || pathname === "/") {
    message = "Hi PANTHM AI Labs! I visited panthm.com and would like to discuss a project.";
  } else if (pathname.startsWith("/solutions/")) {
    const parts = pathname.replace("/solutions/", "").split("/").filter(Boolean);
    if (parts.length >= 3) {
      const [service, industry, location] = parts;
      const format = (str) => str.split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
      message = `Hi PANTHM AI Labs! I am interested in ${format(service)} for ${format(industry)} in ${format(location)}. I would like to schedule a demo and discuss pricing.`;
    } else {
      message = "Hi PANTHM AI Labs! I am exploring your Enterprise Solutions Directory and would like to discuss a custom blueprint.";
    }
  } else if (pathname.startsWith("/services/")) {
    const serviceName = pathname.replace("/services/", "").split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
    message = `Hi PANTHM AI Labs! I am interested in your ${serviceName} services. Please share details and pricing.`;
  } else if (pathname.includes("voice-ai-demo")) {
    message = "Hi PANTHM AI Labs! I tested your Voice AI Demo and would like to deploy a custom low-latency Voice SDR for my business.";
  } else if (pathname.includes("ai-roi-calculator")) {
    message = "Hi PANTHM AI Labs! I calculated our team's potential savings on your AI ROI Calculator and want to discuss deployment.";
  } else if (pathname.includes("ai-audit-generator")) {
    message = "Hi PANTHM AI Labs! I ran an AI Readiness Audit on my website and want to implement your recommendations.";
  } else if (pathname.includes("contact")) {
    message = "Hi PANTHM AI Labs! I'm on your Contact page and would like to speak with your technical team.";
  } else if (pathname.includes("blogs")) {
    message = "Hi PANTHM AI Labs! I was reading your technical articles and want to learn more about your AI solutions.";
  }

  return `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(message)}`;
};
